const State = {

    // FIELDS
    "name": "Name",
    "status": "Status",
    "search": "Search",
    "country": "Country",

    // PAGE HEADER
    "state": "State",

    // ERROR
    "error_name": "Enter Name",
    "error_country": "Select Country",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_country": "COUNTRY",
    "table_status": "STATUS",

}

export default State;